export default "__VITE_PUBLIC_ASSET__212ee74a__"